<div class="right-panel h-100 text-grey">
    <div class="d-flex flex-column h-100">
        <div class="actionBar">
            <div class="flex-grow-1 h-100">
                <input class="search w-100" type="text" placeholder="Search by Group policy object"
                    [formControl]="filterText" />
            </div>
            <button *ngIf="isMonitor == false" (click)="addNewGpo()" type="button" class="actionBtn" triggers="hover" ngbTooltip="Add new group policy">
              <span class="bi bi-person-workspace"></span>
              <span class="bi bi-plus-circle-fill overlay-icon-plus"></span>
            </button>
        </div>
        <div class="right-side w-100">
            <div class="w-100">
                <div class="listTable">
                    <div class="jobs">
                        <table style="border-collapse: collapse; align-content: flex-start;"
                        class="table table-hover table-condensed" cellspacing="0">
                        <thead>
                            <tr class="jobHeadRow" style="color: White; background-color: var(--s-primary-color);">
                                <th scope="col"  style="max-width: 3%; text-align: center;">
                                    <a style="color: White; text-decoration: none; cursor: default">#</a>
                                </th>
                                <th scope="col">
                                    <a style="color: White; text-decoration: none; cursor: default">Group Policy Object</a>
                                </th>
                                <th *ngIf="isMonitor == false" style="text-align: end; max-width: 5%; padding-right:35px" >Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="jobRow" *ngFor="let gpo of filteredGpo | paginate: { itemsPerPage: itemsPerPage , currentPage: p }; let i = index">
                                <td scope="row" style="width: 3%; text-align: center;">{{ (p - 1) * itemsPerPage + (i + 1) }}</td>
                                <td #titleCell title="{{ gpo }}">
                                  {{ gpo | shortenString : (titleCell.offsetWidth || 250) }}
                                </td>
                                <td *ngIf="isMonitor == false" class="controlActions" style="width: 5%;padding-right:31px;">
                                    <span class="bi bi-pencil-square" (click)="updateGpoProps(gpo)"
                                        title="Update GPO Properties"></span>
                                    <!-- <span class="bi bi-x-lg synchpc-primary" (click)="deleteGPO(gpo)" title="Delete GPO"></span> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination-controls style="padding-top: 0.3rem" *ngIf="gpoNames" class="my-pagination" (pageChange)="p = $event">
                    </pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ngx-spinner bdColor="rgba(0,0,0,0)" size="default" zIndex="1" color="var(--s-primary-color)" type="ball-spin"
        [fullScreen]="false" name="gpoList">
        <p class="pleaseWait">Please wait ...</p>
    </ngx-spinner>
</div>
